import { ip_back } from "../config";
import { evalVideoExtension } from "../utils/evalVideoEncoding";

function authHeader() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token ? { Authorization: token } : {};
}

export async function uploadTableReplay({
  blobs,
  teId,
  tsId,
  replayId,
  coachId,
  tableNumber,
  recordingFps,
  videoBitrate,
  recordingResolution,
  replayVideoQuality,
  clientDebug,
}) {
  const form = new FormData();
  (blobs || []).forEach((blob, index) => {
    const ext = evalVideoExtension(blob?.type);
    form.append("videoMessage", blob, `table-replay-${index}.${ext}`);
  });
  form.append("te_id", String(teId || ""));
  if (tsId) form.append("ts_id", String(tsId));
  if (replayId) form.append("replay_id", String(replayId));
  if (coachId) form.append("coach_id", String(coachId));
  if (tableNumber != null) form.append("table_number", String(tableNumber));
  if (recordingFps != null) form.append("recording_fps", String(recordingFps));
  if (videoBitrate != null) form.append("video_bitrate", String(videoBitrate));
  if (recordingResolution) {
    form.append("recording_resolution", String(recordingResolution));
  }
  if (replayVideoQuality) {
    form.append("replay_video_quality", String(replayVideoQuality));
  }
  if (clientDebug) {
    try {
      form.append("client_debug", JSON.stringify(clientDebug).slice(0, 20000));
    } catch {
      /* ignore */
    }
  }

  const resp = await fetch(`${ip_back}api/mobileAPI/tableReplayVideo`, {
    method: "POST",
    headers: authHeader(),
    body: form,
  });
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || json.status === "error") {
    throw new Error(json.message || "Replay upload failed");
  }
  return json.data || null;
}

async function postJson(path, messageId) {
  const resp = await fetch(`${ip_back}api/mobileAPI/${path}`, {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ message_id: messageId }),
  });
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || json.status === "error") {
    throw new Error(json.message || "Replay request failed");
  }
  return json.data || null;
}

export function saveTableReplay(messageId) {
  return postJson("saveTableReplay", messageId);
}

export function deleteTableReplay(messageId) {
  return postJson("deleteTableReplay", messageId);
}
